/* eslint-disable prefer-destructuring */
/* eslint-disable import/extensions */
/* eslint-disable no-param-reassign */
import { mapState } from 'vuex';
import NP from 'number-precision';
import diff from 'diff-arrays-of-objects';
import { webBleMixin } from '@/assets/webBleMixin/webBleMixin.js';

export const graphMixin = {
  mixins: [webBleMixin],
  computed: {
    ...mapState([
      'connectedDevices',
      'mobilenet',
      'exportKnnClassifiers',
      'exportKnnDataSet',
      'cameraRef',
      'wifiCameraRef',
      'isCameraOn',
      'isWifiCameraOn']),
  },
  data() {
    return {
      adjList: {},
      inputNodes: {},
      outputBuffer: {},
      previousOutput: {},
      AIModelsValue: {},
      inputBuffer: {},
      timerBuffer: {},
      counterBuffer: {},
      excuteTime: 0,
      dataSet: [],
      terminal: false,
      cycleInGraph: [],
    };
  },
  methods: {
    // ----------------------------------- Calculator ---------------------------------
    addition(...args) {
      return NP.plus(...Array.from(args));
    },
    subtraction(...args) {
      return NP.minus(...Array.from(args));
    },
    multiplication(...args) {
      return NP.times(...Array.from(args));
    },
    division(...args) {
      return NP.round(NP.divide(...Array.from(args)), 2);
    },
    module(...args) {
      return args[0] % args[1];
    },
    power(...args) {
      return args[0] ** args[1];
    },
    // ------------------------------------ Comparison -----------------------------------
    equality(...args) {
      return Array.from(args).every((el, i, arr) => el === arr[0]) ? 1 : 0;
    },
    greater(...args) {
      return args[0] > args[1] ? 1 : 0;
    },
    greaterEqual(...args) {
      return args[0] >= args[1] ? 1 : 0;
    },
    inequality(...args) {
      return args[0] !== args[1] ? 1 : 0;
    },
    less(...args) {
      return args[0] > args[1] ? 0 : 1;
    },
    lessEqual(...args) {
      return args[0] >= args[1] ? 0 : 1;
    },
    // -------------------------------------- Logic -----------------------------------------
    logicAnd(...args) {
      return Array.from(args).every((el) => el > 0) ? 1 : 0;
    },
    logicOr(...args) {
      return Array.from(args).some((el) => el > 0) ? 1 : 0;
    },
    logicNAnd(...args) {
      return Array.from(args).every((el) => el > 0) ? 0 : 1;
    },
    logicNOr(...args) {
      return Array.from(args).some((el) => el > 0) ? 1 : 0;
    },
    logicNot(...args) {
      return args[0] > 0 ? 0 : 1;
    },
    logicXor(...args) {
      const firstNum = args[0] > 0 ? 1 : 0;
      const secondNum = args[1] > 0 ? 1 : 0;
      return firstNum !== secondNum ? 1 : 0;
    },
    randomRange(...args) {
      const min = Math.ceil(args[1]);
      const max = Math.floor(args[0]);
      if (max < min) {
        return 0;
      }
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    // -------------------------------------- Graph -----------------------------------------
    addVectex(vertex) {
      this.adjList[vertex] = [];
      this.inputNodes[vertex] = [];
      this.outputBuffer[vertex] = {};
      this.inputBuffer[vertex] = {};
    },
    addEdge(vertex1, vertex2, output, input) {
      this.adjList[vertex1].push({
        vertex: vertex2,
        input,
      });
      this.inputNodes[vertex2].push({
        from: vertex1,
        output,
        to: vertex2,
        input,
      });
    },
    // -------------------------------------- cache -----------------------------------------
    setStartTime() {
      this.excuteTime = new Date().getTime();
      this.timerBuffer = {};
    },
    setStartCounter() {
      this.counterBuffer = {};
    },
    setPreviousOutput() {
      this.previousOutput = {};
    },
    setData(data) {
      this.dataSet = data;
      this.adjList = {};
      this.inputNodes = {};
      this.outputBuffer = {};
      this.inputBuffer = {};
      this.AIModelsValue = {};
      // clear all node
    },
    resetBFS() {
      this.setStartTime();
      this.setStartCounter();
      this.setPreviousOutput();
    },
    // -------------------------------------- dfs/bfs -----------------------------------------
    dfs() {
      // this dfs for find out node in cycle
      this.cycleInGraph = [];
      const wSet = Object.keys(this.adjList);

      for (let i = 0; i < wSet.length; i += 1) {
        const path = [];
        this.dfs_util(wSet[i], path);
      }
      // console.log(this.cycleInGraph);
    },

    dfs_util(node, bSet) {
      // console.log(node, bSet)
      let thisNodePath = [...bSet];
      if (thisNodePath.includes(node)) {
        // console.log("here is a loop", node, thisNodePath);
        thisNodePath = thisNodePath.slice(thisNodePath.indexOf(node));
        thisNodePath = thisNodePath.sort();

        const result = diff(
          this.cycleInGraph,
          [
            {
              isVisited: false,
              cycle: thisNodePath,
            },
          ],
          'cycle',
        );
        this.cycleInGraph = this.cycleInGraph.concat(result.added);
      } else {
        thisNodePath.push(node);
        const neighbors = this.adjList[node];
        for (let i = 0; i < neighbors.length; i += 1) {
          this.dfs_util(neighbors[i].vertex, thisNodePath);
        }
      }
    },

    findStartNodes() {
      const nodes = Object.keys(this.inputNodes);
      let startNodes = nodes.filter((node) => this.inputNodes[node].length === 0);

      if (startNodes.length === 0) {
        startNodes = nodes;
      }
      return startNodes;
    },
    checkPreviousNodeAllExcuted(node, inculdeArray) {
      return this.inputNodes[node].every((el) => inculdeArray.includes(el.from));
    },
    checkIsInCycle(node) {
      let isInCycle = false;
      for (let i = 0; i < this.cycleInGraph.length; i += 1) {
        if (this.cycleInGraph[i].cycle.includes(node) && this.cycleInGraph[i].isVisited === false) {
          this.cycleInGraph[i].isVisited = true;
          isInCycle = true;
        }
      }
      return isInCycle;
    },
    generateexcuteArray() {
      const excuteArray = [];
      const inCycle = {};

      const startArray = this.findStartNodes();

      // excuteArray = [...startArray];

      while (startArray.length) {
        const thisNode = startArray.shift();
        excuteArray.push(thisNode);
        const neighbors = this.adjList[thisNode];

        for (let i = 0; i < neighbors.length; i += 1) {
          const neighbor = neighbors[i].vertex;
          if (!excuteArray.includes(neighbor)) {
            if (this.checkPreviousNodeAllExcuted(neighbor, excuteArray)) {
              startArray.push(neighbor);
              // excuteArray.push(neighbor);
            } else if (this.checkIsInCycle(neighbor)) {
              inCycle[neighbor] = true;
              startArray.push(neighbor);
              // excuteArray.push(neighbor);
            }
          }
        }
      }
      return {
        excuteArray,
        inCycle,
      };
    },
    async aiPrediciton(vertex) {
      console.log(`${vertex.label}start`);
      const knnName = vertex.label;

      const labelToId = {};
      Object.keys(this.exportKnnDataSet[knnName]).forEach((key) => {
        labelToId[this.exportKnnDataSet[knnName][key].name] = key;
      });
      const idToIndex = {};
      vertex.properties.aiProps.forEach((el, i) => {
        console.log(el, i);
        idToIndex[labelToId[el.name]] = i;
      });
      this.AIModelsValue[vertex.id] = {};
      const valueArray = Array(vertex.properties.outputCount).fill(0);
      let logits;
      let infer;
      if (this.isCameraOn) {
        infer = () => this.mobilenet.infer(this.cameraRef, 'conv_preds');
      } else if (this.isWifiCameraOn) {
        infer = () => this.mobilenet.infer(this.wifiCameraRef, 'conv_preds');
      } else {
        return;
      }
      // const infer = () => this.mobilenet.infer(document.getElementById('video'), 'conv_preds');
      const numClasses = this.exportKnnClassifiers[knnName].getClassExampleCount();
      console.log(knnName, numClasses, this.exportKnnClassifiers[knnName]);
      if (numClasses) {
        logits = infer();
        await this.exportKnnClassifiers[knnName]
          .predictClass(logits, 10)
          .then((result) => {
            console.log(result);
            Object.keys(result.confidences).forEach((el) => {
              const idx = idToIndex[el];
              valueArray[idx] = Math.floor(result.confidences[el] * 100);
            });
            console.log(valueArray);
            valueArray.forEach((el, i) => {
              this.AIModelsValue[vertex.id][`output${i + 1}`] = el;
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
      console.log(`${vertex.label}End`);
    },

    async aiProcess(vertexs) {
      console.log('pre AI', vertexs);

      while (!(vertexs.length === 0)) {
        const cur = vertexs.pop();
        // eslint-disable-next-line no-await-in-loop
        await this.aiPrediciton(cur);
      }

      console.log(this.AIModelsValue);
      return this.AIModelsValue;
    },
    async bfs() {
      // find cycle by using dfs
      this.dfs();
      // and generate excute array by bfs
      const info = this.generateexcuteArray();

      const nodeQueue = [...info.excuteArray];
      const inCycle = JSON.parse(JSON.stringify(info.inCycle));

      console.log('======>', nodeQueue, inCycle);

      while (!(nodeQueue.length === 0)) {
        const currentNode = nodeQueue.shift();
        // console.log(currentNode);
        // eslint-disable-next-line no-await-in-loop
        await this.excuteOp(
          currentNode,
          Object.prototype.hasOwnProperty.call(inCycle, currentNode),
        );
      }

      this.previousOutput = JSON.parse(JSON.stringify(this.outputBuffer));
      // console.log(this.previousOutput, this.outputBuffer);

      // console.log(this.AIModelsValue)
      const totalResult = {
        nodes: {
          outputBuffer: this.outputBuffer,
          inputBuffer: this.inputBuffer,
          AIModelsBuffer: this.AIModelsValue,
        },
        terminal: this.terminal,
      };
      return totalResult;
    },
    getBLEcommand(gadgetsProp) {
      let commandToReturn = -1;
      switch (gadgetsProp.type) {
        case 'Infrared':
          if (gadgetsProp.port === 'Port 1' && gadgetsProp.sensor === 'Sensor 1') {
            commandToReturn = 1;
          } else if (gadgetsProp.port === 'Port 1' && gadgetsProp.sensor === 'Sensor 2') {
            commandToReturn = 2;
          } else if (gadgetsProp.port === 'Port 2' && gadgetsProp.sensor === 'Sensor 1') {
            commandToReturn = 3;
          } else if (gadgetsProp.port === 'Port 2' && gadgetsProp.sensor === 'Sensor 2') {
            commandToReturn = 4;
          }
          break;
        case 'Ultrasound':
          commandToReturn = 5;
          break;
        default:
          break;
      }

      return commandToReturn;
    },
    async excuteOp(vertex, needUsePreviousValue) {
      const typeOfOp1 = this.dataSet.vectexs[vertex].styleClass.firstClass;
      const typeOfOp2 = this.dataSet.vectexs[vertex].styleClass.secondClass;
      const opPoperties = this.dataSet.vectexs[vertex].properties;

      const inputArray = Array(opPoperties.inputCount).fill(0);
      const inputConnect = Array(opPoperties.inputCount).fill(0);
      this.inputNodes[vertex].forEach((el) => {
        if (typeof this.outputBuffer[el.from][el.output] !== 'undefined') {
          inputArray[el.input] = this.outputBuffer[el.from][el.output];
        } else {
          inputArray[el.input] = 0;
        }
        inputConnect[el.input] = 1;
      });

      if (needUsePreviousValue && Object.keys(this.previousOutput).length > 0) {
        console.log('need use previous:', this.previousOutput);
        this.inputNodes[vertex].forEach((el) => {
          inputArray[el.input] = this.previousOutput[el.from][el.output];
          inputConnect[el.input] = 1;
        });
      }

      inputArray.forEach((el, i) => {
        this.inputBuffer[vertex][`input${i + 1}`] = el;
      });

      // console.log("this node input", inputArray)

      let opOuptputs = null;
      if (Object.prototype.hasOwnProperty.call(opPoperties, 'outputs')) {
        opOuptputs = Object.keys(this.dataSet.vectexs[vertex].properties.outputs);
      }

      switch (typeOfOp1) {
        case 'Constant': {
          const values = [opPoperties.value];
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = values[i];
            return o;
          }, {});
          break;
        }
        case 'Arithmetic': {
          let arithmeticResult = [];
          if (typeOfOp2 === 'Addition') {
            arithmeticResult = [this.addition.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Subtraction') {
            arithmeticResult = [this.subtraction.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Multiplication') {
            arithmeticResult = [this.multiplication.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Division') {
            arithmeticResult = [this.division.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Modulo') {
            arithmeticResult = [this.module.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Power') {
            arithmeticResult = [this.power.apply(null, inputArray)];
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = arithmeticResult[i];
            return o;
          }, {});
          break;
        }
        case 'Comparison': {
          let compareResult = [];
          if (typeOfOp2 === 'Equality') {
            compareResult = [this.equality.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Greater') {
            compareResult = [this.greater.apply(null, inputArray)];
          } else if (typeOfOp2 === 'GreaterEqual') {
            compareResult = [this.greaterEqual.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Inequality') {
            compareResult = [this.inequality.apply(null, inputArray)];
          } else if (typeOfOp2 === 'Less') {
            compareResult = [this.less.apply(null, inputArray)];
          } else if (typeOfOp2 === 'LessEqual') {
            compareResult = [this.lessEqual.apply(null, inputArray)];
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = compareResult[i];
            return o;
          }, {});
          break;
        }
        case 'Logic': {
          let logicResult = [];
          if (typeOfOp2 === 'AND') {
            logicResult = [this.logicAnd.apply(null, inputArray)];
          } else if (typeOfOp2 === 'OR') {
            logicResult = [this.logicOr.apply(null, inputArray)];
          } else if (typeOfOp2 === 'NAND') {
            logicResult = [this.logicNAnd.apply(null, inputArray)];
          } else if (typeOfOp2 === 'NOR') {
            logicResult = [this.logicNOr.apply(null, inputArray)];
          } else if (typeOfOp2 === 'XOR') {
            logicResult = [this.logicXor.apply(null, inputArray)];
          } else if (typeOfOp2 === 'NOT') {
            logicResult = [this.logicNot.apply(null, inputArray)];
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = logicResult[i];
            return o;
          }, {});
          break;
        }
        case 'Random': {
          const randomresult = [this.randomRange.apply(null, inputArray)];
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = randomresult[i];
            return o;
          }, {});
          break;
        }
        case 'Boolean': {
          const result = [];
          if (typeOfOp2 === 'True') {
            result.push(1);
          } else if (typeOfOp2 === 'False') {
            result.push(0);
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = result[i];
            return o;
          }, {});
          break;
        }
        case 'Timer': {
          console.log(inputArray);
          if (inputArray.every((el) => el > 0)) {
            this.timerBuffer[vertex] = new Date().getTime();
          }

          let timeResult = 0;
          if (Object.prototype.hasOwnProperty.call(this.timerBuffer, vertex)) {
            timeResult = [new Date().getTime() - this.timerBuffer[vertex]];
          } else {
            timeResult = [new Date().getTime() - this.excuteTime];
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = timeResult[i];
            return o;
          }, {});
          break;
        }
        case 'Counter': {
          let previousTriggerValue = 0;
          let nowCount = inputArray[1];
          if (Object.prototype.hasOwnProperty.call(this.previousOutput, vertex)) {
            console.log('need use previous:', this.previousOutput);
            nowCount = this.previousOutput[vertex].output1;
          }
          let counterResult = [nowCount];

          if (Object.prototype.hasOwnProperty.call(this.counterBuffer, vertex)) {
            previousTriggerValue = this.counterBuffer[vertex];
          } else {
            previousTriggerValue = inputArray[0];
          }
          this.counterBuffer[vertex] = inputArray[0];
          if (inputArray[2] === 1) {
            // Reset counter to initial value
            counterResult = [inputArray[1]];
          } else if (
            typeOfOp2 === 'CounterUp'
            && previousTriggerValue === 0
            && inputArray[0] === 1
          ) {
            console.log('here 1');
            counterResult = [nowCount + 1];
          } else if (
            typeOfOp2 === 'CounterDown'
            && previousTriggerValue === 0
            && inputArray[0] === 1
          ) {
            console.log('here 2');
            counterResult = [nowCount - 1];
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = counterResult[i];
            return o;
          }, {});
          break;
        }
        case 'Terminal': {
          if (inputArray.every((el) => el > 0)) {
            this.terminal = true;
          } else {
            this.terminal = false;
          }
          break;
        }
        case 'Gadgets': {
          // check some op connected
          console.log(inputArray, inputConnect);
          const sensorCommand = this.getBLEcommand(opPoperties.gadgetsProp);
          const gadgetsResult = [0];
          // eslint-disable-next-line no-prototype-builtins
          if (opPoperties.gadgetsProp.ble.hasOwnProperty('mac') && sensorCommand !== -1) {
            const bleMac = opPoperties.gadgetsProp.ble.mac;
            if (Object.prototype.hasOwnProperty.call(this.connectedDevices, bleMac)) {
              const thisDevice = this.connectedDevices[bleMac];
              if (inputArray.every((el) => el > 0 || inputConnect.every((input) => input === 0))) {
                gadgetsResult[0] = await this.sendRawDataToDeviceAndWaitForRes(
                  sensorCommand,
                  thisDevice,
                  10000,
                );
              }
            }
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = gadgetsResult[i];
            return o;
          }, {});
          break;
        }
        case 'Actions': {
          const actionResult = [0];
          // eslint-disable-next-line no-prototype-builtins
          if (opPoperties.actionsProp.ble.hasOwnProperty('mac')) {
            const bleMac = opPoperties.actionsProp.ble.mac;
            const actionCommand = opPoperties.actionsProp.code;
            const thisDevice = this.connectedDevices[bleMac];
            if (inputArray.every((el) => el > 0 || inputConnect.every((input) => input === 0))) {
              actionResult[0] = await this.sendRawDataToDeviceAndWaitForRes(
                actionCommand,
                thisDevice,
                10000,
              );
            }
          }
          this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
            o[c] = actionResult[i];
            return o;
          }, {});

          break;
        }
        case 'AIModels': {
          console.log('AI');
          const knnName = this.dataSet.vectexs[vertex].label;
          // Get id to output idx
          const labelToId = {};
          Object.keys(this.exportKnnDataSet[knnName]).forEach((key) => {
            labelToId[this.exportKnnDataSet[knnName][key].name] = key;
          });
          // console.log(labelToId);
          const idToIndex = {};
          this.dataSet.vectexs[vertex].properties.aiProps.forEach((el, i) => {
            console.log(el, i);
            idToIndex[labelToId[el.name]] = i;
          });
          // console.log(idToIndex);

          this.AIModelsValue[vertex] = {};
          const AIModelsResult = Array(opPoperties.outputCount).fill(0);
          const valueArray = Array(opPoperties.outputCount).fill(0);
          if (inputArray.every((el) => el > 0 || inputConnect.every((input) => input === 0))) {
            // prepare img data
            let logits;
            let infer;
            if (this.isCameraOn) {
              infer = () => this.mobilenet.infer(this.cameraRef, 'conv_preds');
            } else if (this.isWifiCameraOn) {
              infer = () => this.mobilenet.infer(this.wifiCameraRef, 'conv_preds');
            } else {
              return;
            }

            // get that knn

            const numClasses = this.exportKnnClassifiers[knnName].getClassExampleCount();
            console.log(knnName, numClasses, this.exportKnnClassifiers[knnName]);
            if (numClasses) {
              logits = infer();
              await this.exportKnnClassifiers[knnName]
                .predictClass(logits, 10)
                .then((result) => {
                  console.log(result);
                  Object.keys(result.confidences).forEach((el) => {
                    const idx = idToIndex[el];
                    valueArray[idx] = Math.floor(result.confidences[el] * 100);
                  });
                  // console.log(valueArray);
                  // check the max is the only one
                  const maxValueCount = valueArray.reduce((howmany, currentValue) => {
                    if (currentValue === Math.max(...valueArray)) {
                      howmany += 1;
                    }
                    return howmany;
                  }, 0);

                  if (maxValueCount === 1 && Math.max(...valueArray) >= 70) {
                    AIModelsResult[valueArray.indexOf(Math.max(...valueArray))] = 1;
                  }
                  valueArray.forEach((el, i) => {
                    this.AIModelsValue[vertex][`output${i + 1}`] = el;
                  });
                  // console.log(valueArray, AIModelsResult);
                  this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
                    o[c] = AIModelsResult[i];
                    return o;
                  }, {});
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          } else {
            // no need
            valueArray.forEach((el, i) => {
              this.AIModelsValue[vertex][`output${i + 1}`] = el;
            });
            // console.log(valueArray, AIModelsResult);
            this.outputBuffer[vertex] = opOuptputs.reduce((o, c, i) => {
              o[c] = AIModelsResult[i];
              return o;
            }, {});
          }
          break;
        }
        default:
          break;
      }
    },
  },
};

export default graphMixin;

// connectedDevices: {},
// preConnectionNumber: 0,
// mobilenet: null,
// knnClassifier: null,
// exportKnnClassifiers: {},
